import React from 'react';
import PropTypes from 'prop-types';

const LayoutErrorFallback = props => {
  const { error = '' } = props;

  // TODO: Update layout internal error view
  return (
    <div>
      <div>Oops, something went wrong</div>
      <div>{error.message}</div>
    </div>
  );
};

export default LayoutErrorFallback;

LayoutErrorFallback.propTypes = {
  error: PropTypes.string,
};
